var map = {
	"./Antibiotic Sensitivity Discs.2.jpg": "0e06",
	"./CRP LATEX.2(mid).jpg": "4f76",
	"./Cholesterol CHOD POD.2(mid).jpg": "ef12",
	"./GOT (AST).2(mid).jpg": "a13a",
	"./Glucose GOD POD.2(mid).jpg": "869b",
	"./Hematology Reagents Kit.2 (mid).jpg": "9e9e",
	"./Monoscan Groupage .2 (mid).jpg": "4778",
	"./Tests-fotor(mid).jpg": "1e7c",
	"./Total Protein Biuret.2 (mid).jpg": "4911",
	"./Turbilatex Reagents 01.2 (mid).jpg": "8f78",
	"./Turbilatex Reagents 02.2(mid).jpg": "3e0b",
	"./Turbilatex Reagents 03.2(mid).jpg": "98b7",
	"./Urine Strips.2mid).jpg": "44f8",
	"./stains1.png": "c18c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85ae";